import React, { useState } from 'react';
import Tesseract from 'tesseract.js';
import * as pdfjsLib from 'pdfjs-dist';
import { Copy, FileUp, Loader2, X } from 'lucide-react';
import { toast } from 'react-toastify';
import styles from './Modal.module.css'; // Use o seu arquivo de estilos padrão

// Configura o worker do PDF.js (necessário para ler PDFs no browser)
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function ModalOCR({ onClose }) {
    const [loading, setLoading] = useState(false);
    const [textoExtraido, setTextoExtraido] = useState('');
    const [progresso, setProgresso] = useState('');

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setTextoExtraido('');
        
        try {
            let imageSrc = file;

            // Se for PDF, renderiza a primeira página para um Canvas
            if (file.type === 'application/pdf') {
                setProgresso('Lendo PDF...');
                const arrayBuffer = await file.arrayBuffer();
                const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
                const page = await pdf.getPage(1); // Lê a página 1 (pode ser adaptado para iterar todas)
                
                const viewport = page.getViewport({ scale: 2.0 }); // Escala 2.0 melhora a precisão do OCR
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                await page.render({ canvasContext: context, viewport: viewport }).promise;
                imageSrc = canvas.toDataURL('image/png');
            }

            setProgresso('Aplicando OCR (isso pode demorar alguns segundos)...');
            
            // Roda o Tesseract
            const { data: { text } } = await Tesseract.recognize(
                imageSrc,
                'por', // Português
                { logger: m => m.status === 'recognizing text' && setProgresso(`Lendo texto: ${Math.round(m.progress * 100)}%`) }
            );

            setTextoExtraido(text);
            toast.success("Texto extraído com sucesso!");
        } catch (error) {
            console.error(error);
            toast.error("Erro ao ler o documento.");
        } finally {
            setLoading(false);
            setProgresso('');
        }
    };

    const copiarTexto = () => {
        navigator.clipboard.writeText(textoExtraido);
        toast.success("Copiado para a área de transferência!");
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'grid', placeItems: 'center', zIndex: 9999 }}>
            <div style={{ background: '#fff', padding: '2.0rem', borderRadius: '4px', width: '600px', maxWidth: '90vw', display: 'flex', flexDirection: 'column', gap: '1.6rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 >Extrair Texto (OCR)</h2>
                    <button onClick={onClose} className={styles.modalClose}><X /></button>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '1.6rem' }}>
                    <label>
                        <FileUp size={16} /> Selecionar PDF ou Imagem
                        <input className={styles.inputHide  } type="file" accept=".pdf,image/*" onChange={handleFileUpload} hidden />
                    </label>
                    {loading && <span style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', color: '#666' }}><Loader2 className="spin" size={16} /> {progresso}</span>}
                </div>

                <textarea 
                    value={textoExtraido} 
                    onChange={e => setTextoExtraido(e.target.value)}
                    placeholder="O texto extraído aparecerá aqui..."
                    style={{ width: '100%', height: '300px', padding: '0.8rem', border: '0.1rem solid #ccc', borderRadius: '4px', resize: 'vertical' }}
                />

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.8rem' }}>
                    <button type="button" onClick={copiarTexto} disabled={!textoExtraido} className={textoExtraido ? 'styles.iniciarVotacao' : 'styles.pausarVotacao'} >
                    </button>
                </div>
            </div>
        </div>
    );
}